import React from 'react';
import { Pie } from 'react-chartjs-2';
import styled from 'styled-components';
import i18n from '../i18n';
import { Card, CardTitle, CardBody } from '../styled/Card';

const placeData = (data) => {
  const { children, teenagers, young_adults, adults, mature, seniors } = data;

  return ({
    labels: [
      i18n.t('clientsDemography.children'),
      i18n.t('clientsDemography.teenagers'),
      i18n.t('clientsDemography.youngAdults'),
      i18n.t('clientsDemography.adults'),
      i18n.t('clientsDemography.mature'),
      i18n.t('clientsDemography.seniors')
    ],
    datasets: [
      {
        label: i18n.t('clientsDemography.title'),
        data: [
          children?.raw_count_all || 0,
          teenagers?.raw_count_all || 0,
          young_adults?.raw_count_all || 0,
          adults?.raw_count_all || 0,
          mature?.raw_count_all || 0,
          seniors?.raw_count_all || 0,
        ],
        backgroundColor: ['#00B97F', '#CCEFF1', '#005938', '#9DD7E7', '#69A4DB', '#C0E88E'],
      },
    ],
  })
};

const ClientsDemography = (props) => {
  const { clients_demography } = props.data;

  return (
    <Card>
      <CardTitle>{i18n.t('clientsDemography.title')}</CardTitle>
      <CardBody padding={'20px'}>
        <Pie data={placeData(clients_demography || {})} />
      </CardBody>
    </Card>
  )
};

export default ClientsDemography;

const Header = styled.div`
  text-align: center;
`;
